import { colors, mono } from '../theme';

export function StatCard({ title, value, valueColor }: { title: string; value: number | string; valueColor?: string }) {
  return (
    <div style={{
      padding: '16px 20px',
      background: colors.panel,
      border: `1px solid ${colors.border}`,
      borderRadius: '10px',
      flex: '1 1 160px',
      minWidth: '140px',
    }}>
      <div style={{ fontSize: '12px', color: colors.textDim, textTransform: 'uppercase', letterSpacing: '0.04em' }}>{title}</div>
      <div style={{ fontSize: '26px', fontWeight: 700, marginTop: '6px', fontFamily: mono, color: valueColor ?? colors.text }}>{value}</div>
    </div>
  );
}
